
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yard-debris-removal",
      function () {
        return require("private-next-pages/yard-debris-removal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yard-debris-removal"])
      });
    }
  